module.exports = __webpack_public_path__ + "static/calorie-counter-mobile-plp-75af64728aff3d49c88ca0db9842b547.png";